import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { CropperSettings } from 'ngx-img-cropper';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { ImageCropperWithPreviewComponent } from 'common/components/image.cropper/image.cropper.component';
import { ShowImageModalActions, ShowImageModalData } from './show.image.modal.provider';

@Component({
  templateUrl: './show.image.modal.component.html',
  styleUrls: ['./show.image.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowImageModalComponent extends BaseComponent {
  public imageData = { image: null };
  public data: ShowImageModalData;
  public hubName: string;
  public cropperSettings: CropperSettings;
  public isImgLoaded = false;

  constructor(
    private dialogRef: MatDialogRef<ShowImageModalComponent>,
    private actions: ShowImageModalActions,
    private imageService: ImageService,
    private apiService: VisitorApiService,
    data: ShowImageModalData
  ) {
    super();
    this.data = Object.assign({}, data);
    if (!this.data || !this.data.data) {
      console.log('no data in image modal');
      return;
    }
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    this.actions.confirm(event, this.data.data);
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.image.modal/show.image.modal.component.ts